import { extendTailwindMerge, type ClassNameValue } from "tailwind-merge"

export const tailwindMergeConfig = {
  extend: {
    theme: {
      text: [
        "display",
        "title",
        "title-body",
        "body-lg",
        "body",
        "body-uppercase",
        "body-sm",
        "link-large",
        "link",
      ],
      color: [
        "cobalt-50",
        "cobalt-100",
        "cobalt-200",
        "cobalt-300",
        "cobalt-400",
        "cobalt-500",
        "cobalt-600",
        "cobalt-700",
        "gray-1000",
        "v2-foreground-default",
        "v2-foreground-default-disabled",
        "v2-foreground-inverse",
        "v2-foreground-inverse-disabled",
        "v2-foreground-active",
        "v2-foreground-primary",
        "v2-foreground-primary-strong",
        "v2-foreground-primary-stronger",
        "v2-foreground-primary-disabled",
        "v2-foreground-danger",
        "v2-foreground-danger-disabled",
        "v2-background-canvas",
        "v2-background-elevation",
        "v2-background-surface",
        "v2-background-surface-inverse",
        "v2-background-surface-strong",
        "v2-background-surface-stronger",
        "v2-background-surface-disabled",
        "v2-background-surface-inset",
        "v2-background-primary",
        "v2-background-primary-strong",
        "v2-background-primary-stronger",
        "v2-background-primary-disabled",
        "v2-background-danger",
        "v2-background-danger-strong",
        "v2-background-danger-disabled",
        "v2-background-success",
        "v2-background-accent",
        "v2-background-active",
        "v2-background-active-hover",
        "v2-background-surface-tonal",
        "v2-background-surface-tonal-strong",
        "v2-background-surface-tonal-stronger",
        "v2-background-danger-tonal",
        "v2-background-danger-tonal-strong",
        "v2-background-danger-tonal-stronger",
        "v2-foreground-danger-tonal",
        "v2-foreground-danger-tonal-strong",
        "v2-foreground-danger-tonal-stronger",
        "v2-background-alert-tonal",
        "v2-background-alert-tonal-strong",
        "v2-background-alert-tonal-stronger",
        "v2-foreground-alert-tonal",
        "v2-foreground-alert-tonal-strong",
        "v2-foreground-alert-tonal-stronger",
        "v2-background-success-tonal",
        "v2-background-success-tonal-strong",
        "v2-background-success-tonal-stronger",
        "v2-foreground-success-tonal",
        "v2-foreground-success-tonal-strong",
        "v2-foreground-success-tonal-stronger",
        "v2-background-information-tonal",
        "v2-background-information-tonal-strong",
        "v2-background-information-tonal-stronger",
        "v2-foreground-information-tonal",
        "v2-foreground-information-tonal-strong",
        "v2-foreground-information-tonal-stronger",
        "v2-background-ai-tonal",
        "v2-background-ai-tonal-strong",
        "v2-background-ai-tonal-stronger",
        "v2-foreground-ai-tonal",
        "v2-foreground-ai-tonal-strong",
        "v2-foreground-ai-tonal-stronger",
        "v2-foreground-default-weak",
        "v2-foreground-alert",
        "v2-foreground-success",
        "v2-foreground-information",
        "v2-foreground-ai",
        "v2-background-danger-weak",
        "v2-background-alert-weak",
        "v2-background-success-weak",
        "v2-background-information-weak",
        "v2-background-ai-weak",
        "v2-border-alert",
        "v2-border-success",
        "v2-border-information",
        "v2-border-ai",
        "v2-border-default",
        "v2-border-default-disabled",
        "v2-border-strong",
        "v2-border-stronger",
        "v2-border-active",
        "v2-border-danger",
        "v2-border-focus",
        "v2-border-swatch-ring",
      ],
      shadow: [
        "shadow-input",
        "shadow-control",
        "shadow-surface",
        "v2-button",
        "v2-input",
      ],
      animate: [
        "animate-dot-pulse",
        "animate-skeleton-pulse",
        "animate-shimmer",
        "animate-dooey-spin",
      ],
      spacing: ["page-gutter"],
    },
    classGroups: {
      "text-color": [
        "color-default",
        "color-subtle",
        "color-subtler",
        "color-subtlest",
        "color-inverse",
        "color-selected",
        "color-disabled",
        "color-link",
        "color-danger",
        "color-warning",
        "color-success",
        "color-information",
        "color-button-default",
        "color-button-disabled",
        "color-button-white-default",
        "color-accent-green",
        "color-accent-sky",
        "color-accent-blue",
        "color-accent-violet",
        "color-accent-red-subtle",
        "color-accent-green-subtle",
        "color-accent-violet-subtle",
        "color-brand-default",
        "color-icon-default",
        "color-icon-subtle",
        "color-icon-subtlest",
        "color-icon-bold",
        "color-icon-inverse",
        "color-icon-selected",
        "color-icon-disabled",
        "color-icon-danger",
        "color-icon-warning",
        "color-icon-success",
        "color-icon-information",
        "color-icon-accent-amber",
        "color-icon-accent-green",
        "color-icon-accent-sky",
        "color-icon-accent-blue",
        "color-icon-accent-violet",
        "color-icon-white-default",
        "color-icon-white-disabled",
      ],
      "bg-color": [
        "bg-accent-red",
        "bg-accent-amber",
        "bg-accent-green",
        "bg-accent-sky",
        "bg-accent-sky-subtle",
        "bg-accent-blue",
        "bg-accent-violet",
        "bg-accent-violet-default",
        "bg-accent-violet-alternate",
        "bg-accent-violet-hovered",
        "bg-accent-violet-pressed",
        "bg-glass-violet-default",
        "bg-accent-pink",
        "bg-accent-gray",
        "bg-accent-bold-red",
        "bg-accent-bold-sky",
        "bg-accent-bold-blue",
        "bg-input-default",
        "bg-input-bold",
        "bg-input-hovered",
        "bg-input-disabled",
        "bg-input-pressed",
        "bg-gray-default",
        "bg-neutral-default",
        "bg-neutral-alternate",
        "bg-neutral-hovered",
        "bg-neutral-pressed",
        "bg-neutral-bold-default",
        "bg-selected-default",
        "bg-selected-alternate",
        "bg-selected-hovered",
        "bg-selected-pressed",
        "bg-primary-default",
        "bg-primary-disabled",
        "bg-danger-default",
        "bg-warning-default",
        "bg-success-default",
        "bg-information-default",
        "bg-brand-default",
        "bg-elevation-surface-default",
        "bg-elevation-surface-hovered",
        "bg-elevation-surface-container-default",
        "bg-elevation-surface-container-lowest-default",
        "bg-elevation-surface-accent-default",
        "bg-icon-white-default",
        "bg-icon-white-disabled",
        "bg-icon-bold",
      ],
      "border-color": [],
      "divide-color": ["divider-accent-violet-subtle"],
      stroke: [],
    },
  },
}

const twMerge = extendTailwindMerge(tailwindMergeConfig)

export function classNames(...classes: ClassNameValue[]): string {
  return twMerge(classes)
}
